// Форматирует остаток времени до таймаута обработки matching-выплаты (PAYOUT_TIMEOUT).
// Длительность таймаута не хардкодится: приходит абсолютный дедлайн matchingTimeoutAt (ISO-8601),
// здесь считается только остаток относительно nowMs. Порог красной подсветки — < 30 минут.
const MS_MIN = 60_000
const MS_HOUR = 60 * MS_MIN
const DANGER_THRESHOLD_MS = 30 * MS_MIN

export interface MatchingTimeoutView {
  text: string
  danger: boolean
}

export function formatMatchingTimeout(
  matchingTimeoutAt: string | null | undefined,
  nowMs: number
): MatchingTimeoutView | null {
  if (!matchingTimeoutAt) {
    return null
  }

  const deadlineMs = new Date(matchingTimeoutAt).getTime()
  if (Number.isNaN(deadlineMs)) {
    return null
  }

  const remainingMs = deadlineMs - nowMs

  if (remainingMs <= 0) {
    return { text: 'Срок истек', danger: true }
  }

  if (remainingMs >= MS_HOUR) {
    const hours = Math.floor(remainingMs / MS_HOUR)
    return { text: `Остается ${hours}ч`, danger: false }
  }

  const minutes = Math.floor(remainingMs / MS_MIN)
  return { text: `Остается ${minutes}м`, danger: remainingMs < DANGER_THRESHOLD_MS }
}
